import {createBorder} from '../../common';

declare let THREE: any;

export class Rect extends (THREE.Mesh as { new(geometry, material): any; }) {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));

  public static readonly Name = 'Rect';

  constructor(size: number, texture) {
    const geometry = new THREE.PlaneBufferGeometry(size, size).applyMatrix(Rect.rotationTransform);
    const material = new THREE.MeshBasicMaterial({
      side: THREE.DoubleSide,
    });
    super(geometry, material);
    let canvas = document.createElement('canvas');

    let ctx = canvas.getContext('2d');

    canvas.width = 100;
    canvas.height = 100;
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    if (!this.material.map) {
      this.material.map = new THREE.Texture(canvas);
    }
    this.material.map.image = canvas;

    this.material.map.needsUpdate = true;
    this.material.needsUpdate = true;

    material.map.center.set(0.5, 0.5);
    const border = createBorder(geometry.clone());
    this.add(border);
    this.name = Rect.Name;
  }

  updateTextureRotation(parent) {
    this.material.map.rotation = -parent.rotation.y;
    this.material.map.needsUpdate = true;
    this.material.needsUpdate = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/Rect.ts